import { jsxs as e, jsx as l } from "react/jsx-runtime";

import { startOfDay as r, isFirstDayOfMonth as t, getMonth as o, startOfMonth as a, isSameDay as i, format as s } from "date-fns";

import { useMemo as n, useCallback as x } from "react";

import m from "@ui-components-3/ui/lib/utils/classNames";

import { useProviderSchedule as p } from "../../../hooks/useProviderSchedule.js";

import f from "../../MonthDaySlots/index.js";

import { SCHEDULE_DATE_FORMAT as d } from "../../../utils.js";

import { useLiveCurrentDate as u } from "../../../hooks/useLiveCurrentDate.js";

const c = ({day: c, className: b}) => {
    const {isMobile: h, date: y, variantClassNames: v, slots: g, toggleDrawer: w} = p(), N = u(), j = n((() => r(N)), [ N ]), O = n((() => !(o(c) === o(y)) && t(c)), [ c, y ]), k = n((() => a(c).valueOf() > a(y).valueOf()), [ c, y ]), D = n((() => a(c).valueOf() < a(y).valueOf()), [ y, c ]), L = n((() => i(j, c)), [ j, c ]), C = n((() => !!D || !!k), [ k, D ]), M = n((() => r(c).valueOf() < r(j).valueOf()), [ j, c ]), S = n((() => `${s(c, d)}${L ? ", Today" : ""}`), [ c, L ]), T = n((() => g?.filter((e => r(new Date(e.startTime)).valueOf() === r(c).valueOf())) || []), [ c, g ]), $ = x((() => {
        w(!0, {
            day: c
        })();
    }), [ c, w ]), A = !C && !M && !!T?.length;
    return e("div", {
        className: m("gap-xxs xl:p-xs xl:border-1 flex h-full min-h-[80px] flex-nowrap border-neutral-400 transition-colors xl:-ml-[1px] xl:-mt-[1px] xl:min-h-[140px] xl:min-w-[14px] xl:flex-col xl:border", !!C && "xl:bg-neutral-100", !!A && !h && "cursor-pointer hover:bg-neutral-900", b),
        "aria-label": S,
        onClick: A ? $ : void 0,
        children: [ e("div", {
            className: m("gap-xxs flex min-w-[48px] flex-col items-center justify-center xl:min-w-0 xl:flex-row xl:justify-start", C ? "!text-neutral-500" : v.textMainDark),
            children: [ !!O && l("p", {
                className: "min-w typography-body-xl -mr-2.5 font-semibold",
                children: s(c, "LLLL")
            }), h ? l("p", {
                className: "min-w typography-body-l font-semibold",
                children: s(c, "E")
            }) : null, l("p", {
                className: m("typography-body-l xl:typography-body-xl inline-flex h-8 w-8 items-center justify-center rounded-full text-center font-semibold", L && !O ? m("text-white", v.bgMain) : "bg-transparent"),
                children: s(c, "d")
            }) ]
        }), l("div", {
            className: m("border-1 -mt-[1px] flex flex-1 flex-wrap items-start gap-1 border border-neutral-400 p-3 transition-colors xl:mt-0 xl:flex-col xl:flex-nowrap xl:border-0 xl:p-0", !!C && "bg-neutral-100", !!A && !!h && "cursor-pointer hover:bg-neutral-900"),
            children: D ? null : l(f, {
                daySlots: T,
                onAvailableSlotClick: $
            })
        }) ]
    });
};

export { c as default };
//# sourceMappingURL=MonthCalendarCell.js.map
